import { ReactNode } from "react";

interface ActionBannerProps {
  icon: ReactNode;
  title: string;
  description: string;
  buttonText: string;
  buttonIcon?: ReactNode;
  onClick: () => void;
}

const ActionBanner = ({
  icon,
  title,
  description,
  buttonText,
  buttonIcon,
  onClick
}: ActionBannerProps) => {
  return (
    <div className="bg-white dark:bg-[#2c2c2c] border border-gray-200 dark:border-[#454545] rounded-md shadow-sm p-5 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center text-[#00a859]">
          {icon}
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800 dark:text-gray-200 m-0">{title}</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{description}</p>
        </div>
      </div>

      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-2 bg-[#00a859] hover:bg-[#008f4c] text-white px-5 py-2.5 rounded-md font-medium transition-colors shadow-sm whitespace-nowrap">
        {buttonIcon}
        {buttonText}
      </button>
    </div>
  );
};

export { ActionBanner };